import { Theme } from '@mui/material/styles';
import { CommonTheme } from '.';

// eslint-disable-next-line max-lines-per-function
export const buildCommonOverrides = (theme: Theme) => {
  const { borderRadius, palette, spacing, typography } = theme as CommonTheme;
  const backgroundColor = palette.background.paper;
  // eslint-disable-next-line prefer-destructuring
  const borderColor = palette.neutrals[600];
  const overrides: Theme['components'] = {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-hiddenLabel': {
            paddingTop: spacing(0.5),
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontFamily: typography.fontFamily,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: 'filled',
      },
    },
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        root: {
          padding: spacing(0.5, 3),
          borderRadius: borderRadius('s'),
          '&:not(.Mui-error):not(.Mui-disabled):hover': {
            backgroundColor,
            borderColor: palette.primary[500],
            '@media (hover: none)': {
              backgroundColor,
            },
          },
          '&.Mui-focused': {
            backgroundColor,
          },
          '&.Mui-disabled': {
            backgroundColor: palette.neutrals[100],
          },
        },
        input: {
          '&.MuiSelect-select': {
            margin: spacing(-2.5, -3),
            padding: spacing(2.5, 3),
            '&[role="button"]': {
              paddingRight: spacing(12),
            },
          },
          '&.MuiNativeSelect-select': {
            height: `calc(100% + ${spacing(2.5 * 2)})`,
            margin: spacing(0, -3),
            padding: spacing(0, 3),
          },
        },
        focused: {
          backgroundColor,
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          fontSize: '1rem',
        },
        fontSizeMedium: {
          fontSize: '1.5rem',
        },
        fontSizeLarge: {
          fontSize: '2rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        focused: {
          backgroundColor,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          padding: spacing(0.5, 3),
          border: '1px solid',
          transition: 'border-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
          '&:not(.Mui-error):not(.Mui-disabled)': {
            backgroundColor,
            borderColor,
            '&:hover, :focus-within': {
              borderColor: palette.primary.main,
            },
          },
          '& > button': {
            minHeight: 'auto',
          },
        },
        focused: {
          backgroundColor,
          borderColor: palette.primary.main,
        },
        disabled: {
          backgroundColor: palette.neutrals[100],
        },
        input: {
          padding: spacing(2, 0),
          '&[type="search"]': {
            // this is required for desktop Safari, otherwise search inputs look like $*%t
            WebkitAppearance: 'textfield',
          },
          '&::placeholder': {
            color: palette.neutrals[600],
            opacity: 1,
          },
        },
        error: {
          borderColor: palette.error[500],
          backgroundColor: palette.error[100],
          color: palette.error[500],
        },
      },
    },
    MuiNativeSelect: {
      defaultProps: {
        disableUnderline: true,
      },
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          margin: spacing(2, 0),
        },
        switchBase: {
          padding: 7,
          '&.Mui-checked+.MuiSwitch-track': {
            opacity: 1,
          },
        },
        track: {
          backgroundColor: palette.neutrals[600],
          opacity: 1,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled',
      },
    },
  };
  return overrides;
};
